export class Event {
  public event: string;
  public eventBy: string;
  public props?: any;
  public desc?: any;
}
